import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as IconlyPack from "react-iconly";
import useCreateSlide from "../../Dashboard/Admin/DocumentsAdmin/requestDocument/useCreateSlide";
var AddSlideModal = ({ item }) => {
  const { t } = useTranslation();
  const {
    register,
    onSubmit,
    formState,
    isSuccessfullySubmitted,
    clearErrors,
    reset,
    setValue,
    isDone,
  } = useCreateSlide(item);
  const [fileName, setFileName] = useState(null);
  const uploadFile = (e) => {
    console.log("target", e.target);
    setFileName(e.target.files[0].name);
    setValue("image", e.target.files[0]);
  };

  useEffect(() => {
    if (formState.errors) {
      setTimeout(() => {
        Object.entries(formState.errors).map(([key]) => {
          return clearErrors(key);
        });
      }, 3000);
    }
  }, [clearErrors, formState]);

  useEffect(() => {
    if (isDone) {
      setFileName(null);
    }
  }, [isDone]);

  const handleReset = () => {
    setFileName(null);
    reset();
  };

  return (
    <div className="modal-dialog easypm-modal-dialog modal-lg">
      <div className="modal-content easypm-modal-content">
        <div className="modal-header easypm-modal-header">
          <h5 className="modal-title easypm-modal-title" id="AddSlideModal">
            {item ? t("edit_slide") : t("add_slide")}
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => handleReset()}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body easypm-modal-body">
          <div className="add-family-form-container">
            <form className="crud-form" onSubmit={onSubmit}>
              <div className="row crud-row">
                <div className="col-md-12 crud-col-item">
                  <div className="">
                    <div className="form-group crud-form-group">
                      <label htmlFor="nom">
                        {t("title")}
                        <span className="required-label">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder={t("title")}
                        name="title"
                        {...register("title")}
                        className="form-control input-add-document"
                      />
                      {formState.errors && formState.errors.title && (
                        <div className="alert alert-danger gfa-alert-danger">
                          {formState.errors.title?.message}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-12 crud-col-item">
                  <div className="">
                    <div className="form-group crud-form-group">
                      <label htmlFor="description">
                        {t("order")}
                        <span className="required-label">*</span>
                      </label>
                      <input
                        type="number"
                        placeholder={t("order")}
                        name="order"
                        {...register("order")}
                        className="form-control input-add-document"
                      />
                      {formState.errors && formState.errors.order && (
                        <div className="alert alert-danger gfa-alert-danger">
                          {formState.errors.order?.message}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-12 crud-col-item">
                  <div className="">
                    <div className="form-group crud-form-group">
                      <div>
                        Image
                        <span className="required-label">*</span>
                      </div>
                      <div className="inputfile-box">
                        <input
                          type="file"
                          id={item ? `file${item.id}` : "file"}
                          className="inputfile  input-add-document"
                          onChange={(e) => uploadFile(e)}
                        />
                        <label htmlFor={item ? `file${item.id}` : "file"}>
                          <span
                            id="file-name"
                            className="file-box input-add-document"
                          >
                            <span className="text-input-file-costum">
                              {fileName || t("upload_file")}
                            </span>
                          </span>
                          <span className="file-button">
                            <IconlyPack.Upload
                              set="light"
                              primaryColor="#000"
                            />
                          </span>
                        </label>
                      </div>
                      {formState.errors && formState.errors.image && (
                        <div className="alert alert-danger gfa-alert-danger">
                          {formState.errors.image?.message}
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-12 mt-4">
                  {isSuccessfullySubmitted && (
                    <button disabled className="btn crud-submit-btn">
                      {t("en_cours")} &nbsp;
                      <i className="fas fa-spin fa-spinner"></i>
                    </button>
                  )}
                  {!isSuccessfullySubmitted && (
                    <button type="submit" className="btn crud-submit-btn">
                      {t(item ? "edit" : "add")}
                    </button>
                  )}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSlideModal;
